export const environment = {
  production: true,
  envName: 'qa',
  endPoint: 'https://ene-dsiapisvc-002-q.azurewebsites.net',
  appInsights: {
    instrumentationKey: 'df181261-2316-4191-889c-f5836319f432'
  },
  adalConfig: {
    tenant: 'c1eb5112-7946-4c9d-bc57-40040cfe3a91',
    clientId: '37824aae-783f-40f7-8398-62c375895d65',
    navigateToLoginRequestUrl: false,
    postLogoutRedirectUri: window.location.origin + '/',
    isAngular: true,
    cacheLocation: 'sessionStorage'
  },
  userVoiceConfig: {
    apiKey: 'hcRvYu0ptNzRD4wlcplp9g',
    forumID: '923338'
  },
  defaultLanguage: 'en',
  supportedLanguages: [
    'en'
  ]
};



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/environments/environment.ts